import getConfig from 'next/config';
import request from '@utils/request';
import { Personalization } from 'shared-types';

const previewUrl = '/options';

export const getPreviewId = async (
  body: {
    printablePersonalization?: Personalization | null;
    printableDateFrom: string;
  },
  showModal: (boolean) => void,
  setPreviewToken: (number) => void,
  previewType: string,
  id?: number
) =>
  request.post(`${id}/${previewType}${previewUrl}`, body).then((response: any) => {
    setPreviewToken(response.data.id);
    showModal(true);
  });

export const { BACKEND_URL } = getConfig().publicRuntimeConfig;
